import React from 'react';
import { Typography } from 'antd';
import ForkliftMobileCard from './ForkliftMobileCard';

const { Text } = Typography;

export default function ForkliftMobileCardList({
  forklifts,
  loading,
  navigate,
  selectedRowId,
  setSelectedRowId,
}) {
  return (
    <div className="customer-preview-mobile-forklift-list" aria-busy={loading}>
      {forklifts.length ? (
        forklifts.map((forklift) => (
          <ForkliftMobileCard
            key={forklift.id}
            forklift={forklift}
            navigate={navigate}
            onSelect={() => setSelectedRowId(forklift.id)}
            selected={forklift.id === selectedRowId}
          />
        ))
      ) : (
        <div className="customer-preview-mobile-empty">
          <Text type="secondary">No active lifts match the current filters.</Text>
        </div>
      )}
    </div>
  );
}
